<template>
  <p v-if="selectedStore" class="footer-address">
    <strong>{{ selectedStore.txtLocationName }}</strong>
    <br />
    {{ selectedStore.txtAddress }}
    <br />
    {{ selectedStore.txtCity }}, {{ selectedStore.full_state }} {{ selectedStore.txtZip }}
    <br />
    <a v-bind:href="`/store/${selectedStore.slugPartner}/${selectedStore.slugCityState}/${selectedStore.slugLocation}`"
      >View Store Details</a
    >
    <br />
    <a href="#" data-open="locatorModal">Change Locations</a>
    <br />
    <a href="/">Corporate Homepage</a>
  </p>
</template>

<style lang="scss" scoped>
@import "~@styles/scss/base/variables";

.footer-address {
  display: inline-block;
  margin-right: auto;
  margin-left: auto;
}
</style>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState, mapActions } = createNamespacedHelpers("location");

export default {
  data() {
    return {};
  },

  computed: {
    ...mapState(["selectedStore"]),
  },

  mounted: function () {
    this.requireSelectedStore();
  },

  methods: {
    ...mapActions(["requireSelectedStore"]),
  },
};
</script>
